import { get, post } from '@/utils/http.js'

//菜单添加
export const getRouters = (data) => get('/user/getRouters/4');

// //菜单详情
// export const menudetail = (id) => get('/tr_api/v1/power/detail-menu/'+id);

// //菜单修改 
// export const updatemenu = (data) => post('/tr_api/v1/power/update-menu',data)

// //菜单删除
// export const delmenu = (data) => post('/menu/delete',data);

// //菜单列表
// export const menulist = (data) => post('/menu/findall',data);

// //菜单树状列表
// export const treemenu = () => get('/tr_api/v1/power/tree-menu');
